import React, { useContext } from 'react';
import { getTranslatedString } from 'helpers/i18n';
import Stats from '../../common/Stats';
import { CurrentApplicationContext } from '../../ApplicationOverview';

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const LeaseOverviewStats = () => {
  const application = useContext(CurrentApplicationContext);

  return (
    <Stats
      items={[
        {
          title: translate('overview.statistics.created'),
          value: application.lease.lifecycle?.created_at
            ? new Date(application.lease.lifecycle?.created_at)
            : null,
        },
        {
          title: translate('overview.statistics.sent'),
          value: application.lease.lifecycle?.sent_at
            ? new Date(application.lease.lifecycle?.sent_at)
            : null,
        },
        {
          title: translate('overview.statistics.signed'),
          value: application.lease.lifecycle?.signed_at
            ? new Date(application.lease.lifecycle?.signed_at)
            : null,
        },
        {
          title: translate('overview.statistics.counterSigned'),
          value: application.lease.lifecycle?.counter_signed_at
            ? new Date(application.lease.lifecycle?.counter_signed_at)
            : null,
        },
      ]}
    />
  );
};

export default LeaseOverviewStats;
